<template>
	<div id="List">
		<!-- banner -->
		<div v-if='!Nav.lanmu.Logo && !Nav.PColumn || Nav.lanmu.Logo =="http://base.hope55.com" && Nav.PColumn.Logo == "http://base.hope55.com"' class="banner"></div>
		<div v-else-if="Nav.lanmu.Logo==''&& !Nav.PColumn==''" class="banner"></div>
		<div v-else class="banner" :style="{'background-image': 'url('+( Nav.lanmu.Logo ? Nav.lanmu.Logo : Nav.PColumn.Logo )+')'}"></div>
		<!-- 导航 -->
		<div class="navList">
			<div class="clearfix">
				<div class="topDh">
					<!-- 当前位置 -->
					<address-bar :addressBarData="Nav"></address-bar>
				</div>
				<div class="main w69" :style="{minHeight: winHeight+'px'}">
					<div id="infoBox">
						<div v-if="NId" class="newsDetails">
							  <template>
									<p class="title">{{List.Title}}</p>
									<p class="related_information">
									  <span>时间：{{List.ShowTime}}</span>
									  <span>浏览次数：{{List.Press}}</span>
									</p>
							  </template>
						  <div class="info" v-html="List.Details"></div>
					   </div>
					   <div v-else-if="HType==1" v-html="List.Info"  class="singleBox"></div>
					   <component-view  v-else  :option='{dataList: List ,componentType: currentValue}' ></component-view>
					   <!-- 分页 -->
					   <page-box :pageBoxData="List.PageBar" :pageIndex="PageIndex"></page-box>
					   <!-- <div class="paging" id="page_turn_box">
                  <a href="">首页</a>
                  <a href="">上一页</a>
                  <a href="" class="on">1</a>
                  <a href="">2</a>
                  <a href="">3</a>
                  <a href="">下一页</a>
                  <a href="">末页</a>
              </div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../assets/css/list.css';
	import addressBar from '@/components/addressBar'
	import pageBox from '@/components/pageBox'
	import componentView from '../components/componentView'
	export default{
		name:'list',
		components:{
			addressBar,
			pageBox,
			componentView
		},
		data(){
			return{
			   CId:this.$route.query.CId,
			   NId:this.$route.query.NId,
			   PageIndex:this.$route.query.PageIndex,
			   HType:this.$route.query.HType,
			   Nav:'',
			   item:'',
				 winHeight: window.innerHeight-866,
			   List:[],
			   currentData: '',
       		   currentValue: 'pageBox'
			}
		},
		created(){
			this.Nav = this.Curren.SetClassStyle(this.CId);
			this.Nav.List=[];
			this.Nav.lanmu.Fid > 0?this.Nav.List = this.$root.$children['0'].$children['0'].menuListOne.filter(ele=> ele.ID==this.Nav.lanmu.Fid)[0].Children : this.Nav.List.push(this.Nav.lanmu)
			if( this.$root.$children['0'].$children['0'].menuListOne){
				this.$root.$children['0'].$children['0'].menuListOne.forEach(element => { // 确定菜单点击项
			        element.ID == this.CId ? element.On = true : element.On = false
			    });
			}
			if(this.NId){//详情
				this.List = this.Base.GetNewsInfoByNid(this.NId);
			}else if(this.HType==1){
				this.List = this.Base.GetSinglePageInfoByCid(this.CId);
				// console.log(this.List)
			}else{
			    if(this.CId ==6273 ||this.CId == 6274) {this.List = this.Base.GetNewsInfoByCid(this.CId,true,this.PageIndex,'',5);this.currentValue = 'ImgList';}//有图 师资队伍
          else if(this.CId == 6271|| this.CId == 6275|| this.CId == 6276){ this.List = this.Base.GetNewsInfoByCid(this.CId,false,this.PageIndex,'',5);this.currentValue = 'noImgList';} //无图本院动态
          else if(this.CId == 6270|| this.CId == 6268){ this.List = this.Base.GetNewsInfoByCid(this.CId,false,this.PageIndex,'',5);this.currentValue = 'Notice';} //无图本院动态
          else if(this.CId == 6272) {this.List = this.Base.GetNewsInfoByCid(this.CId,true,this.PageIndex,'',6);this.currentValue = 'ImgTextList'; }//图文列表
        //   else if(this.CId == 3439 ){ this.List = this.Base.GetFilesInfoByCid(this.CId,this.PageIndex,'',6);this.currentValue = 'Video' }
        //   else if(this.CId == 6274){ this.List = this.Base.GetFilesInfoByCid(this.CId,this.PageIndex,'',6);this.currentValue = 'FileList' }
        //  else if(this.CId == 3447 || this.CId == 3448) this.List = this.Base.GetNewsInfoByCid(this.CId,false,this.PageIndex,'',6,200),this.currentValue = 'TextList';
        //  else if(this.CId == 3454) this.List = this.Base.GetNewsInfoByCid(this.CId,true,this.PageIndex,'',6),this.currentValue = 'TeacherList';
        //  else if(this.CId == 3465) this.List = this.Base.GetFilesInfoByCid(this.CId,this.PageIndex,'',8),this.currentValue = 'DownList';// 下载中心
         else if(this.CId == 12087) this.List =[],this.currentValue = 'mailbox'
         if(this.HType == 1) this.List = this.Base.GetSinglePageInfoByCid(this.CId);
				//  console.log(this.Nav,'nav');
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/list.vue